import MessageBroker from 'wrapper/lib/MessageBroker'

import AttachIFrame from 'wrapper/lib/frames/utils/AttachIFrame'
import ZoidGenerator from 'wrapper/lib/frames/utils/ZoidGenerator'

export const ARBITER_ID = 'pico_arbiter'

const Arbiter = (data = {}) => {
    const style = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '1px',
        height: '1px',
        zIndex: '-99999',
        overflow: 'hidden',
        ...data.style,
    }

    const arbiter = ZoidGenerator({
        tag: ARBITER_ID,
        url: `https://${process.env.HOSTNAME}/arbiter/index.${process.env.DATE_HASH}.html`,
    })

    return AttachIFrame({
        id: ARBITER_ID,
        zoid: arbiter,
        data,
        sendHostMessage: MessageBroker,
        style,
    })
}

export default Arbiter
